import { render } from "./Header.vue?vue&type=template&id=c2ba1f70"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c2ba1f70&lang=scss"

import exportComponent from "/Users/andrewdrury/Desktop/code/website/altPhoto/photography/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__